export default __webpack_public_path__ + "static/media/usc_social_graph.40c6884f.png";